export const POST_REDIRECT_KEY = 'acp_post_login_redirect_url';
export const POST_REDIRECT_PARAMETERS_KEY =
  'acp_post_login_redirect_parameters';
